module.exports = __webpack_public_path__ + "img/de_dust2_night.c1c1af32.jpg";